import { Injectable } from '@angular/core';
import { INfsFile } from 'src/interfaces/nfsfile.interface';
import { NfsFileModel } from 'src/models/nfsfile.model';
import { environment } from 'src/environments/environment';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root',
})
export class NfsListService {
  constructor(private conn: ConnectionService) {}

  public async all(table: string): Promise<NfsFileModel[]> {
    const res = await this.conn.post(`${environment.URL_SERVER}/list`, {
      query: 'files',
      value: {
        table: table,
      },
    });
    return NfsFileModel.fromJsonArray(res as INfsFile[]);
  }

  public async getXmlData(
    table: string,
    file: INfsFile,
  ): Promise<NfsFileModel> {
    const res = await this.conn.post(`${environment.URL_SERVER}/list`, {
      query: 'item',
      value: {
        table: table,
        id: file._id,
      },
    });
    return NfsFileModel.fromJson(res as INfsFile);
  }

  public async getXmlDataByChave(
    table: string,
    chave: string,
  ): Promise<NfsFileModel> {
    const res = await this.conn.post(`${environment.URL_SERVER}/list`, {
      query: 'chave',
      value: {
        table: table,
        chave: chave,
      },
    });
    return NfsFileModel.fromJson(res as INfsFile);
  }
}
